<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        <span v-if="type==1">提供岗位</span>
        <span v-if="type==2">志愿服务</span>
        <span v-if="type==3">爱心捐赠</span>
        <span v-if="type==4">时间银行</span>
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHome()">
        <van-icon name="wap-home" size="21"/>
      </div>
    </div>
    <div class="padding content" v-if="type==1">
      <div class="list" @click="toGuide(1)">公益性岗位</div>
      <div class="list" @click="toGuide(2)">按比例安置</div>
      <div class="list" @click="toGuide(3)">集中安置</div>
    </div>
    <div class="padding content" v-if="type==2">
      <div class="list" @click="toVolunteer(1)">志愿者个人注册</div>
      <div class="list" @click="toVolunteer(2)">志愿者团队注册</div>
    </div>
    <div class="padding content" v-if="type==3">
      <div class="list" @click="toDonate()">物资</div>
    </div>
    <div class="padding content" v-if="type==4">
      <div class="list" @click="toTime()">时间银行</div>
    </div>
  </div>
</template>
<script>
import { Icon, Field } from "vant";
import { wantMenu } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
  },
  data() {
    return {
      info: [],
      type: "",
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let type = this.$route.query.type;
    this.type = type;
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
      // this.$router.push("/index");
    },
    toGuide(t) {
      this.$router.push({
        path: "/helpForm",
        query: {
          type: t,
        },
      });
    },
    toDonate(){
      this.$router.push("/helpDonate");
    },
    toTime(){
      this.$router.push("/time");
    },
    toVolunteer(t){
       this.$router.push({
        path: "/helpVolunteer",
        query: {
          type: t,
        },
      });
    }
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}
.info-tit {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 1rem 0;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
  text-indent: 2rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
</style>


// WEBPACK FOOTER //
// src/page/helpMenu.vue